import axios from "axios";
import React, { useEffect, useState } from "react";
import { SERVER_URL } from "../constant";
import { LinearProgress } from "@mui/material";
import AlertBox from "../component/AlertBox";
import { useDispatch } from "react-redux";
import { reloadToggle } from "../store/reload.slice";
import { Link } from "react-router-dom";

function Notification() {
  const [unopenedNotifications, setUnopenedNotofications] = useState(0);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [notificationData, setNotificationData] = useState([]);
  const [reload, setReload] = useState(false);
  const dispatch = useDispatch();

  //fetch all notifications
  async function getNotifications() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/get/notifications`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      let rawData = res.data?.data;
      let totalUnopenedNotification = 0;
      rawData?.map((e) => {
        if (e?.isOpen === false) {
          totalUnopenedNotification = totalUnopenedNotification + 1;
        }
      });
      setUnopenedNotofications(totalUnopenedNotification);
      let reversedArray = [];
      let notificationLen = rawData.length;

      // reversing the array to show latest data to the top
      for (let index = notificationLen - 1; index >= 0; index--) {
        // saving index value because the operation will fail in backend if the index value is inappropiate
        let newObj = { ...rawData[index], index: index };
        reversedArray.push(newObj);
      }
      // console.log(reversedArray);
      setNotificationData(reversedArray);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getNotifications();
  }, [reload]);

  // update notification status
  async function updateNotificationStatus(data, index) {
    try {
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/update/notifications`,
        method: "post",
        data: {
          data: data,
          index: index,
        },
        withCredentials: true,
      });
      setReload((prev) => !prev);
      dispatch(reloadToggle());
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
    } finally {
    }
  }

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            Notifications
          </h1>
          <div className="mt-[3rem] w-full">
            {notificationData?.length === 0 ? (
              <p className="text-center text-slate-500 font-medium mt-5">
                You're all caught up!
              </p>
            ) : (
              <div className="w-full">
                <p className="text-center font-medium text-slate-700">
                  {unopenedNotifications} unread notifications
                </p>
                <div className="mt-5 w-full space-y-2">
                  {notificationData?.map((e, i) => (
                    <Link to={`${e?.link}`} key={i}>
                      <section
                        className={`${
                          e?.isOpen === true ? "" : "bg-sky-100/70"
                        } py-3 px-3 cursor-pointer hover:bg-slate-100`}
                        onClick={() => updateNotificationStatus(e, e?.index)}
                      >
                        <p className="font-medium">
                          {e?.message}{" "}
                          {e?.isOpen === false ? (
                            <span className="text-[14px] bg-sky-500 text-white px-3 py-1 rounded-full font-medium ml-2">
                              Action required
                            </span>
                          ) : (
                            ""
                          )}
                        </p>
                        <p className="flex w-full justify-between items-center mt-2 text-[15px] text-slate-500">
                          {e?.date}
                        </p>
                      </section>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Notification;
